import React, { useEffect } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: relative;
`

export default function LightYoutube({ youTubeId }) {
  useEffect(() => {
    // Ensure the custom element is registered.
    import('@justinribeiro/lite-youtube')
  }, [])

  return (
    <Wrapper>
      <lite-youtube
        videoId={youTubeId}
        autoload
        posterquality="maxresdefault"
        posterloading="eager"
        params={`rel=0&modestbranding=1&iv_load_policy=3&playsinline=1&loop=0&enablejsapi=1&playlist=${youTubeId}`}
      />
    </Wrapper>
  )
}

